import { apiClient } from './client';
import { API_ENDPOINTS } from './endpoints';
import { LabTest } from '../types/api.types';

export interface CreateLabTestDto {
  name: string;
  description?: string;
}

export interface UpdateLabTestDto {
  id: number;
  name: string;
  description?: string;
}

export const labTestsApi = {
  getAll: async (): Promise<LabTest[]> => {
    const response = await apiClient.get<LabTest[]>(API_ENDPOINTS.LAB_TESTS);
    return response.data;
  },
  create: async (data: CreateLabTestDto): Promise<LabTest> => {
    const response = await apiClient.post<LabTest>(API_ENDPOINTS.LAB_TESTS, data);
    return response.data;
  },
  update: async (id: number, data: UpdateLabTestDto): Promise<LabTest> => {
    const response = await apiClient.put<LabTest>(`${API_ENDPOINTS.LAB_TESTS}/${id}`, data);
    return response.data;
  },
  remove: async (id: number): Promise<void> => {
    await apiClient.delete(`${API_ENDPOINTS.LAB_TESTS}/${id}`);
  },
};

